import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ToolAccessProfile } from 'services/alfa_tools';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

// Ferramenta em fase alfa: quem não tem acesso volta para o painel antes de a
// página montar, sem disparar as buscas dela. A trava é só do front; a API
// continua aberta para qualquer usuário logado.
export function withToolAccess<P>(
  Page: React.ComponentType<P>,
  canAccess: (profile: ToolAccessProfile) => boolean,
): React.FC<P> {
  const GuardedPage: React.FC<P> = (props) => {
    const { profile } = useSelector<ApplicationState, ProfileState>(
      (state) => state.storage.profile,
    );

    if (!canAccess(profile)) return <Redirect to="/painel" />;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Page {...props} />;
  };

  return GuardedPage;
}

export default withToolAccess;
